<template>
  <div class="review-survey-step">
    <Typography variant="h-5"> Review your survey </Typography>
    <div class="d-flex">
      <Button
        outlined
        iconLeft="mdi-eye"
        :disabled="!learningModuleId"
        @click="previewDrawerOpen = true"
      >
        Preview Survey
      </Button>
    </div>
    <div class="d-flex align-center">
      <v-switch
        :input-value="isDraft"
        label="Draft mode (hidden)"
        color="brandPrimary"
        hide-details
        class="pt-0 mt-0"
        @change="$emit('update:isDraft', $event)"
      />
      <HelpTooltip icon-class="ml-4">
        <p class="my-1">
          Draft mode can be toggled at any time. When activated, it is hidden from participants.<br />Note
          that this can negatively affect any programs that the module is in.
        </p>
      </HelpTooltip>
    </div>
    <div>
      <Typography variant="subtitle-1"> Audience </Typography>
      <Typography variant="body-1">
        {{ visibilityText }}<span v-if="!isPublic && groups.length">; {{ groupList }}</span>
      </Typography>
    </div>
    <div>
      <Typography variant="subtitle-1"> Allow survey to be retaken </Typography>
      <Typography variant="body-1"> {{ repeatable ? "Yes" : "No" }} </Typography>
    </div>
    <div>
      <Typography variant="subtitle-1"> Introduction </Typography>
      <Typography variant="body-1"> {{ introductionEnabled ? "Added" : "Not added" }} </Typography>
    </div>
    <div>
      <Typography variant="subtitle-1"> Questions </Typography>
      <Typography variant="body-1"> {{ questionCount }} </Typography>
    </div>
    <SurveyPreviewDrawer v-model="previewDrawerOpen" :surveyId="learningModuleId" />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import HelpTooltip from "@/components/help/HelpTooltip.vue";
import SurveyPreviewDrawer from "@/components/program/admin/SurveyPreviewDrawer.vue";

export default {
  name: "ReviewSurveyStep",
  components: {
    Typography,
    Button,
    HelpTooltip,
    SurveyPreviewDrawer,
  },
  props: {
    visibility: {
      type: String,
      default: "PRIVATE",
    },
    groups: {
      type: Array,
      default: () => [],
    },
    repeatable: {
      type: Boolean,
      default: false,
    },
    introductionEnabled: {
      type: Boolean,
      default: false,
    },
    questionCount: {
      type: Number,
      default: 0,
    },
    isDraft: {
      type: Boolean,
      default: false,
    },
    learningModuleId: {
      type: Number,
      default: null,
    },
  },
  emits: ["update:isDraft"],
  data() {
    return {
      previewDrawerOpen: false,
    };
  },
  computed: {
    visibilityText() {
      return this.isPublic ? "Public" : "Internal";
    },
    isPublic() {
      return this.visibility === "PUBLIC";
    },
    groupList() {
      if (!this.groups.length) return "None";
      return this.groups.map((g) => g.groupDisplayName).join(", ");
    },
  },
};
</script>

<style scoped>
.review-survey-step {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
</style>
